import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@dixa/lib-shared-habla';
import styles from './tableInstrumentLongText.module.scss';
export const TableInstrumentLongText = ({ text, }) => {
    return (_jsxs(_Fragment, { children: [_jsx("span", { children: text }), _jsx(Tooltip, { className: styles.tooltip, content: text, dark: true, wrap: "div", wrapProps: { className: styles.trigger } })] }));
};
